import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { GridRowParams } from "@mui/x-data-grid-pro";

import { COLLECTION_POINT_PAGE_PATH,COLLECTION_POINT_VISIT_PAGE_PATH } from "../../../middleware/routes";
import { getCollectionPointDetail } from "../../../selectors/collectionPoint";
import { PREV_PAGE_PARAM } from "../../../utils/url";
import { CollectionPointPageTab } from "../../CollectionPointPage";

export const useGetCollectionYardsVisitsDetailTableHandlers = () => {
  const history = useHistory();
  const { locationId } = useSelector(getCollectionPointDetail);

  const handleAdditionalRowClick = (params: GridRowParams<any>): void => {
    const visitId = params.row.visitId;

    const prevPage = `${COLLECTION_POINT_PAGE_PATH}?id=${locationId}&tab=${CollectionPointPageTab.CollectionYardVisits}`;

    const urlParams = new URLSearchParams();
    urlParams.set("id", String(locationId));
    urlParams.set("cyvid", String(visitId));
    urlParams.set(PREV_PAGE_PARAM, prevPage);

    history.push(`${COLLECTION_POINT_VISIT_PAGE_PATH}?${urlParams.toString()}`);
  };

  return { handleAdditionalRowClick };
};
